import { JSONContent } from '@tiptap/react';

/**
 * Reads stored note text into editor state. Only the task form writes
 * rich-text JSON, but the create bot accepts any string from any caller — a
 * plain-text note MUST round-trip as visible, editable content, never fall
 * back to an empty editor (saving would then silently remove the note).
 */
export function parseDescriptionJson(description: string | undefined): JSONContent | object {
  if (!description) {
    return {};
  }
  try {
    const parsed: unknown = JSON.parse(description);
    if (parsed && typeof parsed === 'object') {
      return parsed as JSONContent;
    }
  } catch {
    // Not JSON — legacy/externally-written plain text; wrapped below.
  }
  return { type: 'doc', content: [{ type: 'paragraph', content: [{ type: 'text', text: description }] }] };
}

/**
 * True when the rich-text document contains any non-whitespace text. An
 * emptied editor still yields `{type:'doc',content:[{type:'paragraph'}]}`,
 * which is not an empty object — key-count checks would store it as a note.
 */
export function richTextHasContent(node: JSONContent | object): boolean {
  const content = node as JSONContent;
  if (content.text?.trim()) {
    return true;
  }
  return content.content?.some(richTextHasContent) ?? false;
}
